// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X3-a","delete":"styles_delete__3vUs5","update":"styles_update__XN9rJ","add":"styles_add__3E6kN"};